import { render, staticRenderFns } from "./GenerateDoc.vue?vue&type=template&id=47849bde"
import script from "./GenerateDoc.vue?vue&type=script&lang=js"
export * from "./GenerateDoc.vue?vue&type=script&lang=js"
import style0 from "./GenerateDoc.vue?vue&type=style&index=0&id=47849bde&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports